<template>
  <setting-section
    class="vat-settings"
    :title="$t('machineConfig.salesTaxTitle')"
    toggleable
    :value="Number(config.isOpen)"
    @input="v => set('isOpen', v)"
  >
    <div class="od-item__params od-item__params--col">
      <!-- 计税方式：0 = 商品价格已含税；1 = 税额在结算时额外计算（约定沿用 is* 字段 1/0 布尔习惯，需与后端核对） -->
      <div class="od-param">
        <span class="od-param__label">{{ $t('machineConfig.salesTaxCalc') }}</span>
        <el-radio-group
          :value="Number(config.isCalculating)"
          size="mini"
          @input="v => set('isCalculating', v)"
        >
          <el-radio-button :label="0">{{ $t('editUserMachine.taxInclude') }}</el-radio-button>
          <el-radio-button :label="1">{{ $t('editUserMachine.taxunInclude') }}</el-radio-button>
        </el-radio-group>
      </div>

      <!-- 适用范围：1 = 整机统一税率（旧版默认值）；2 = 每个商品单独税率 -->
      <div class="od-param">
        <span class="od-param__label">{{ $t('machineConfig.salesTaxScope') }}</span>
        <el-radio-group
          :value="Number(config.type)"
          size="mini"
          @input="v => set('type', v)"
        >
          <el-radio-button :label="1">{{ $t('editUserMachine.taxTyRateSet') }}</el-radio-button>
          <el-radio-button :label="2">{{ $t('editUserMachine.taxDdRateSet') }}</el-radio-button>
        </el-radio-group>
      </div>

      <div v-if="Number(config.type) !== 2" class="od-param">
        <span class="od-param__label">{{ $t('editUserMachine.taxTyRateBfbSet') }}</span>
        <el-input
          class="od-param__input"
          size="mini"
          type="number"
          :value="config.proportion"
          @input="v => set('proportion', v)"
        >
          <template slot="append">%</template>
        </el-input>
      </div>
      <div v-else class="vat-settings__tip">
        <i class="el-icon-info"></i> {{ $t('editUserMachine.vatRateTips') }}
      </div>
    </div>
  </setting-section>
</template>

<script>
import SettingSection from '../SettingSection.vue';

export default {
  name: 'VatSettings',
  components: { SettingSection },
  props: {
    // config.vatRate 对象：{ isOpen, isCalculating, type, proportion }
    config: { type: Object, default: () => ({}) }
  },
  methods: {
    set(key, val) {
      this.$set(this.config, key, val);
    }
  }
};
</script>

<style lang="scss" scoped>
.vat-settings {
  .od-item__params {
    margin-top: 10px;
    padding-left: 12px;
  }

  .od-item__params--col {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .od-param {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  .od-param__label {
    font-size: 12px;
    color: var(--vtm-ink-2, #486581);
    white-space: nowrap;
    min-width: 90px;
  }

  .od-param__input {
    width: 150px;
  }

  .vat-settings__tip {
    font-size: 12px;
    color: var(--vtm-warn, #b54708);
    line-height: 1.5;

    i {
      margin-right: 4px;
    }
  }
}
</style>
